
import { Attachment } from "../models/Attachment";
import { AxiosConfig } from "./AxiosConfig";
//import { BlobServiceClient, StorageSharedKeyCredential  } from "@azure/storage-blob";
import { BlobServiceClient  } from "@azure/storage-blob";
import { InteractiveBrowserCredential } from "@azure/identity";
import { saveAs } from 'file-saver';
import axios from "axios";
import { UserFile } from "../models/UserFile";
import { AuthUtil } from "../utils/AuthUtil";

// Enter your storage account name
//const account = "mcapseadevoadev1";
// const defaultAzureCredential = new InteractiveBrowserCredential();
// const blobServiceClient = new BlobServiceClient(
//     `https://${account}.blob.core.windows.net`,
//     defaultAzureCredential
//   );
// const defaultAzureCredential = new InteractiveBrowserCredential();
// const blobServiceClient = new BlobServiceClient(
//     `https://${account}.blob.core.windows.net`,
//     defaultAzureCredential
//   );

// Enter your storage account name and shared key
//const account = "mcapseadevoadev1";
//const accountKey = "Iyq+Ii5YlvlaK6jD9iYLAbDbuTN4B59UAgEddS8l13dVVwVQz3KO6sZsG8xmLQj0ZdnPgbG4BOQdf67MHeKDvQ";

// Use StorageSharedKeyCredential with storage account and account key
// StorageSharedKeyCredential is only available in Node.js runtime, not in browsers
// const sharedKeyCredential = new StorageSharedKeyCredential(account, accountKey);
// const blobServiceClient = new BlobServiceClient(
//   `https://${account}.blob.core.windows.net`,
//   sharedKeyCredential
// );

//const account = process.env.STORAGE_ACCOUNT;
//const sas = "<service Shared Access Signature Token>";
//const sas = "?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-05-04T15:52:56Z&st=2021-05-04T07:52:56Z&spr=https&sig=QRvALd1P2ZF9N3za7j1XymzDJeCyxMViRHiYRSkqecY%3D"
//const blobServiceClient = new BlobServiceClient(`https://${account}.blob.core.windows.net${sas}`);


const getAttachmentList = async (
    requestNo:string,
    successCallback: (fileList: any) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get(`/BLOBStorage/GetFileDownloadDetails?requestNo=${requestNo}`);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const deleteAdditionalDocument= async (
    fileId:number,
    successCallback: (result: boolean) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get(`/BLOBStorage/DeleteDocument?fileUploadId=${fileId}`);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

//   const downlodFile1 = async (
//     attchement:Attachment
//   ) => {
//     const containerClient = blobServiceClient.getContainerClient(attchement.containerName.toLowerCase());
//     const blobClient = containerClient.getBlobClient(attchement.blobfileName);
//    // Get blob content from position 0 to the end
//   // In browsers, get downloaded data by accessing downloadBlockBlobResponse.blobBody
//   const downloadBlockBlobResponse = await blobClient.download();
//   const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody);
//   console.log("Downloaded blob content", downloaded);
// //   Promise.resolve(downloadBlockBlobResponse.blobBody).then(function (value) {
// //     //fileDownload(value, fileName)
// //     console.log("Downloaded blob content", value);
// //   });

//   // [Browsers only] A helper method used to convert a browser Blob into string.
//   async function blobToString(blob:any) {
//     const fileReader = new FileReader();
//     return new Promise((resolve, reject) => {
//       fileReader.onloadend = (ev) => {
//         resolve(ev.target!.result);
//       };
//       fileReader.onerror = reject;
//       fileReader.readAsText(blob);
//     });
//   }

//     // try {
//     //   const resp = await AxiosConfig.get(`/BLOBStorage/GetFileDownloadDetails?requestNo=${requestNo}`);
//     //   successCallback(resp.data);
//     // } catch (err: any) {
//     //   // Handle Error Here
//     //   console.error(err);
//     //   errorCallback(err);
//     // }
//   };
const showFile = (blob:Blob, byteArray:number[], extention:string) => {
  if(extention === "pdf") {
    var fileURL = URL.createObjectURL(blob);
    window.open(fileURL,"_blank","width=1200,height=700");
  } else {
    let image = new Image();

    var binary = ''
    var len = byteArray.length;
    for (var i = 0; i < len; i++){
        binary += String.fromCharCode( byteArray[i] );
    }

    //image.src = "data:image/" + extention + ";base64," + btoa(String.fromCharCode(...byteArray));
    image.src = "data:image/" + extention + ";base64," + btoa(binary);

    let w = window.open("","_blank","width=1200,height=700");
    if(w){
      w.document.write(image.outerHTML);
    }
  }
}

const downlodFile = async (
  file:UserFile,
  isDownload:boolean,
  isView:boolean, 
  documentType:string,
  documentName:string,
  successCallback: (success: any) => void,
  errorCallback: (error: Error) => void
) => {
  var formData = new FormData();

      if (documentType==="Vendor") {
        formData.append('fileId', file.fileId.toString());
      }
      else{
        formData.append('fileId', "0");
      }
      //formData.append('fileId', file.fileId.toString());
      formData.append('documentType',documentType);
      formData.append('documentName', documentName.toString());

      let url = process.env.REACT_APP_BASE_URL + "BLOBStorage/GetDownloadStream";
      //let tempFiles = clientConfiguration[`tempFiles.${env}`];
      //alert(tempFiles);
  
      axios({
          //headers: {'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
         //   , 'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
         // },
            headers: {'x-api-key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
            , 'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
          },
          method: 'post',
          responseType: 'arraybuffer', //Force to receive data in a Blob Format
          url: url,
          data: formData
      })
          .then(res => {
              
              // let fileName = "download3.png";
            let fileName = file.fileName;
            let nameParts = fileName.split('.');
            let extention = nameParts[nameParts.length-1];
            let byteArray = Array.from(new Uint8Array(res.data));
            let blob:Blob;

            if(extention === "pdf") {
              blob = new Blob([res.data], { type: 'application/pdf' });
            } 
            else if(extention === "xlsx")
            {
              blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            }
            else {
              blob =  new Blob([res.data], {type: 'application/octet-stream'});
            }
            //show file in popup
            if(isView){
              showFile(blob,byteArray,extention);
            }
            //download file
            if(isDownload){
              saveAs(blob, fileName);
            }
            successCallback(true);
          })
          .catch(error => {
              console.log(error.message);
              errorCallback(error)
          });
};

export const FileDownloadService = {
    getAttachmentList,
    //downlodFile1,
    downlodFile,
    deleteAdditionalDocument
  };
  